
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import * as firebase from 'firebase/app';
  import 'firebase/auth'
  import ProfileAvatar from '@/components/Profile/ProfileAvatar.vue';
  import {authModule, userModule} from '@/utils/store-acessor';
  import LocaleSelector from '@/components/Shared/LocaleSelector.vue';
  import {UserModel} from '@/models/user.model';

  @Component({
    components: {
      LocaleSelector,
      ProfileAvatar
    },
  })
  export default class ActionsAuthenticated extends Vue {
    showConfirmLogoutDialog = false;
    @userModule.Getter('user') user!: UserModel;
    @userModule.Action('clearData') clearUserData: any;
    @authModule.Action('logout') logout: any;

    get photoUrl(): string {
      const {currentUser} = firebase.auth();

      if (this.user?.avatar) {
        return this.user.avatar;
      }

      if (currentUser?.photoURL) {
        return currentUser.photoURL;
      }

      return '';
    }

    get fullname(): string {
      if (this.user) {
        return `${this.user.first_name} ${this.user.last_name}`;
      }
      return ''
    }

    get location() {
      return this.user?.contestant?.location
    }

    toProfile(): void {
      this.$router.replace({path: '/profile/me'})
    }

    toProfileConfig(): void {
      this.$router.replace({name: 'profileConfig'})
    }

    onLogout(): void {
      this.showConfirmLogoutDialog = false;
      if (firebase.auth().currentUser) {
        firebase.auth().signOut();
      }
      this.logout();
      this.clearUserData();
      this.$router.replace({
        name: 'home',
      })
    }
  }
